import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    providerList: { providers: [], total: 0, pageSize: 0, error: null, loading: false },
    activeProvider: { provider: null, error: null, loading: false },
    newProvider: { provider: null, error: null, loading: false },
    updateProvider: { provider: null, error: null, loading: false },
    deleteProvider: { provider: null, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_PROVIDERS:
            return {
                ...state,
                providerList: {
                    ...state.providerList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_PROVIDERS_SUCCESS:
            return {
                ...state,
                providerList: {
                    providers: action.payload.providers,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_PROVIDERS_FAILURE:
            return {
                ...state,
                providerList: {
                    providers: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_PROVIDERS:
            return { ...state, providerList: initialState.providerList }



        case actionTypes.FETCH_PROVIDER:
            return { ...state, activeProvider: { provider: null, error: null, loading: true } }

        case actionTypes.FETCH_PROVIDER_SUCCESS:
            return { ...state, activeProvider: { provider: action.payload.provider, error: null, loading: false } }

        case actionTypes.FETCH_PROVIDER_FAILURE:
            return { ...state, activeProvider: { provider: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_PROVIDER:
            return { ...state, activeProvider: initialState.activeProvider }



        case actionTypes.CREATE_PROVIDER:
            return {
                ...state,
                newProvider: {
                    provider: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_PROVIDER_SUCCESS:
            return {
                ...state,
                newProvider: {
                    provider: action.payload.provider,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_PROVIDER_FAILURE:
            return {
                ...state,
                newProvider: {
                    provider: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_PROVIDER:
            return { ...state, newProvider: initialState.newProvider }




        case actionTypes.UPDATE_PROVIDER:
            return { ...state, updateProvider: { provider: null, error: null, loading: true } }

        case actionTypes.UPDATE_PROVIDER_SUCCESS:
            return { ...state, updateProvider: { provider: action.payload.provider, error: null, loading: false } }

        case actionTypes.UPDATE_PROVIDER_FAILURE:
            return { ...state, updateProvider: { provider: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_PROVIDER:
            return { ...state, updateProvider: initialState.updateProvider }



        case actionTypes.DELETE_PROVIDER:
            return { ...state, deleteProvider: { provider: null, error: null, loading: true } }

        case actionTypes.DELETE_PROVIDER_SUCCESS:
            return { ...state, deleteProvider: { provider: action.payload.provider, error: null, loading: false } }

        case actionTypes.DELETE_PROVIDER_FAILURE:
            return { ...state, deleteProvider: { provider: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_PROVIDER:
            return { ...state, deleteProvider: initialState.deleteProvider }



        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/provider/reducer.js